// extracted by mini-css-extract-plugin
export default {"table":"jMHwt","header":"PR87C","parameters":"Gryxa","cell":"acCJY","parameterName":"uCjaI","row":"tBxhG"};